import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../formInputsV2/styles/tokens';

// v2 look for the "Polizza Emessa" (status 7) panel shown on every purchase
// page: client card + quotes card. The cards themselves reuse InfoCard and
// DetailGrid from InfoBoxV2.styles.

// One card per row: there is little information in each.
export const CompletedGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    gap: 10px;
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const TitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: ${v2Colors.primarySoft};
  font-size: 14px;
  color: ${v2Colors.primary};
`;

export const QuoteList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const QuoteRow = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid ${v2Colors.disabledBorder};
  border-left: 4px solid ${v2Colors.primary};
  border-radius: 12px;
  background: ${v2Colors.surface};
  font-family: ${v2FontFamily};

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex: 0 0 auto;
    width: auto;
    padding: 8px 14px;
    border: 1.5px solid ${v2Colors.primary};
    border-radius: 10px;
    background: ${v2Colors.primarySoft};
    font-size: 13.5px;
    font-weight: 600;
    color: ${v2Colors.primary};
    text-decoration: none;
    transition: background-color 150ms ease, border-color 150ms ease;

    svg {
      font-size: 12px;
      transition: transform 150ms ease;
    }

    &:hover,
    &:focus-visible {
      border-color: ${v2Colors.primary};
      background: ${v2Colors.primary};
      color: #fff;
    }

    &:hover svg {
      transform: translateX(3px);
    }
  }

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: stretch;

    a {
      width: 100%;
    }
  }
`;

export const QuoteInfo = styled.div`
  min-width: 0;

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: ${v2Colors.textMuted};
  }

  p + p {
    margin-top: 2px;
  }

  b {
    font-weight: 600;
    color: ${v2Colors.text};
  }
`;
